require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-concrete-jungle.json") })
        }
      }, "path---videos-concrete-jungle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-concrete-jungle!./.cache/json/videos-concrete-jungle.json
// module id = 947
// module chunks = 231608221292675